(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/store/assets/javascripts/middlewares/tracking-mw.js') >= 0) return;  svs.modules.push('/components/tipsen/store/assets/javascripts/middlewares/tracking-mw.js');
"use strict";

const _RTK = RTK,
  isAnyOf = _RTK.isAnyOf;
const toggleCorrectsTracking = svs.components.tipsen.store.helpers.tracking.toggleCorrectsTracking;
const toggleSubscriptionOption = svs.components.tipsen.store.reducers.playerWagerListSubscriptionSlice.actions.toggleSubscriptionOption;
const wagerListForecastSubscriptionsActions = svs.components.tipsen.store.reducers.playerWagerListSubscriptionSlice.actions.wagerListForecastSubscriptions;
const wagerListForecastSubscriptions = svs.components.tipsen.store.reducers.playerWagerListSubscriptionSlice.selectors.wagerListForecastSubscriptions;
const getLogger = svs.core.log.getLogger;
const logger = getLogger('tipsen:store:mw:tracking');
const isInterestingToggleAllAction = isAnyOf(toggleSubscriptionOption);
const isInterestingToggleIndividualAction = isAnyOf(wagerListForecastSubscriptionsActions.toggleSubscriptionForWager);
const trackingMw = _ref => {
  let getState = _ref.getState;
  return next => action => {
    try {
      if (isInterestingToggleAllAction(action)) {
        const _action$payload = action.payload,
          productId = _action$payload.productId,
          isToggleOn = _action$payload.isToggleOn;
        toggleCorrectsTracking({
          type: 'corrects_coupon',
          productId,
          isToggleOn
        });
      }
      if (isInterestingToggleIndividualAction(action)) {
        var _wagerListForecastSub, _wagerListForecastSub2;
        const _action$payload2 = action.payload,
          productId = _action$payload2.productId,
          wagerId = _action$payload2.wagerId;
        const state = getState();
        const isSubscribed = (_wagerListForecastSub = (_wagerListForecastSub2 = wagerListForecastSubscriptions.selectById(state, wagerId)) === null || _wagerListForecastSub2 === void 0 ? void 0 : _wagerListForecastSub2.isSubscribed) !== null && _wagerListForecastSub !== void 0 ? _wagerListForecastSub : false;
        toggleCorrectsTracking({
          type: 'corrects_coupon_individual',
          productId,
          isToggleOn: !isSubscribed
        });
      }
    } catch (error) {
      logger.warn("Something went wrong ".concat(JSON.stringify(action), ". With args: ").concat(JSON.stringify(action.meta.arg.originalArgs)));
    } finally {
      next(action);
    }
  };
};
setGlobal('svs.components.tipsen.store.middlewares.trackingMw', trackingMw);

 })(window);